import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import FormOFHusbandry from './FormOfHusbandry'
import { Tab } from 'semantic-ui-react'
import MilkTypes from './MilkTypes'

interface Props {
  createdAt: string
  farmer: any
  isSwissDairy: boolean
}

const MaterialInfo: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const [activeIndex, setActiveIndex] = useState<string | number>(0)

  function renderPanes() {
    const panes = [
      {
        menuItem: t('Form of husbandry'),
        key: 'form-husbandry',
        render: () => <FormOFHusbandry {...props} />,
        remove: props.isSwissDairy
      },
      {
        menuItem: t('Milk types'),
        key: 'milk-types',
        render: () => <MilkTypes />
      }
    ]
    return <Tab
      menu={{ secondary: true, pointing: true }}
      activeIndex={activeIndex}
      onTabChange={(e, data) => setActiveIndex(data.activeIndex)}
      panes={panes.filter(pane => !pane.remove)}
    />
  }

  return <Layout
    useSpinner
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    title={''}
  >
    {renderPanes()}
  </Layout>
}
export default MaterialInfo